//
//
//
//
//
//

export default {
  props: {
    fullBordered: Boolean,
    cellBordered: {
      type: Boolean,
      default: true
    },
    contentBordered: {
      type: Boolean,
      default: true
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/x-table/index.vue